import React from 'react';
import { Toaster as ShadcnToaster } from '@/components/ui/toaster';
import { Toaster as SonnerToaster } from '@/components/ui/sonner';

export function GlobalToastRenderers() {
  return (
    <>
      <div data-global-toast-renderer="shadcn">
        <ShadcnToaster />
      </div>
      <div data-global-toast-renderer="sonner">
        <SonnerToaster />
      </div>
    </>
  );
}
